import React, { useState } from 'react';
import { Card, Input, Button, Typography, Space, message, Tag, Row, Col, List } from 'antd';
import { useCommandSocket } from '../../../../../../Hooks/WebSocket/useCommandSocket';

const { Text } = Typography;

interface DeviceCommandCardProps {
  driverUid: string;
}

const EldCommand: React.FC<DeviceCommandCardProps> = ({ driverUid }) => {
  const { eldResponses, sendCommand, isConnected } = useCommandSocket({ driverUid });
  const [textValue, setTextValue] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = (command: string, text: string) => {
    if (!isConnected) return message.error('Socket not connected!');
    if (!command) return;

    setLoading(true);
    sendCommand(command, text.trim());
    message.info('Command sent');
    setTimeout(() => setLoading(false), 1200);
  };

  const handleManualSend = () => handleSend('eld_config', textValue);
  const handleStart = () => handleSend('start_eld_data', '');
  const handleStop = () => handleSend('stop_eld_data', '');

  return (
    <Card
      title={
        <Space>
          <Text strong style={{ fontSize: 16 }}>
            ELD Command
          </Text>
          <Tag color={isConnected ? 'green' : 'red'}>
            {isConnected ? 'Connected' : 'Disconnected'}
          </Tag>
        </Space>
      }
      style={{
        borderRadius: 14,
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        padding: 8,
      }}
    >
      {/* Command controls */}
      <Row gutter={12} align="middle">
        <Col span={8}>
          <Input
            placeholder="Enter text"
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            onPressEnter={handleManualSend}
          />
        </Col>

        <Col span={10}>
          <Space>
            <Button
              type="primary"
              onClick={handleManualSend}
              loading={loading}
              disabled={!textValue}
            >
              Send
            </Button>
            <Button type="default" onClick={handleStart} disabled={!isConnected}>
              Start ELD Data
            </Button>
            <Button type="default" onClick={handleStop} disabled={!isConnected}>
              Stop ELD Data
            </Button>
          </Space>
        </Col>
      </Row>

      {/* Response list */}
      <div style={{ marginTop: 20 }}>
        {eldResponses.length > 0 ? (
          <Card
            size="small"
            title={<Text strong>Device Responses</Text>}
            style={{
              borderRadius: 10,
              maxHeight: 400,
              overflowY: 'auto',
            }}
            bodyStyle={{ padding: '10px 14px' }}
          >
            <List
              dataSource={eldResponses}
              renderItem={(item, index) => {
                let parsedText = item.text;
                try {
                  parsedText = JSON.parse(item.text);
                } catch (e) {}

                return (
                  <List.Item
                    key={index}
                    style={{
                      borderRadius: 8,
                      marginBottom: 10,
                      padding: '10px 14px',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        color: '#1677ff',
                        marginBottom: 6,
                      }}
                    >
                      Response #{eldResponses.length - index}
                    </div>

                    <pre
                      style={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        fontSize: 13,
                        margin: 0,
                      }}
                    >
                      {typeof parsedText === 'string'
                        ? parsedText
                        : JSON.stringify(parsedText, null, 2)}
                    </pre>
                  </List.Item>
                );
              }}
            />
          </Card>
        ) : (
          <Text
            type="secondary"
            style={{
              display: 'block',
              textAlign: 'center',
              marginTop: 10,
            }}
          >
            No response yet
          </Text>
        )}
      </div>
    </Card>
  );
};

export default EldCommand;
